<template>
  <div>
    <a @click.prevent="toggleBtn">
      <span v-if="!expand">
        See more <span>+{{ count | formatNumber }}</span>
      </span>
      <span v-else>See less</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'see-more-button',

  props: {
    count: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      expand: false,
    };
  },

  methods: {
    toggleBtn() {
      this.expand = !this.expand;
      this.$emit('showMore', this.expand);
    },
  },
};
</script>

<style lang="scss" scoped>
div a {
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: $grey-text;
  margin-top: -8px;
  display: block;

  span {
    margin-right: 7px;
  }

  &:not([href]):hover {
    color: darken($grey-text, 20%);
  }
}
</style>
